import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AnusthanPage from "./pages/AnusthanPage";
import BhojDaanPage from "./pages/BhojDaanPage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import StoriesPage from "./pages/StoriesPage";
import FAQPage from "./pages/FAQPage";
import BlogsPage from "./pages/BlogsPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import BeginJourneyPage from "./pages/BeginJourneyPage";
import MyConsultationPage from "./pages/MyConsultationPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import SpiritualServicesAgreementPage from "./pages/SpiritualServicesAgreementPage";
import CancellationPolicyPage from "./pages/CancellationPolicyPage";
import './App.css';

// Layout component that conditionally renders header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  if (isAdminRoute) {
    return <>{children}</>;
  }
  
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="amatya-app" data-testid="app-container">
          <Toaster richColors position="top-right" />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/anusthan" element={<AnusthanPage />} />
              <Route path="/anusthan/:anusthanId" element={<AnusthanPage />} />
              <Route path="/bhoj-daan" element={<BhojDaanPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/stories" element={<StoriesPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/blogs" element={<BlogsPage />} />
              <Route path="/blogs/:slug" element={<BlogDetailPage />} />
              <Route path="/begin-journey" element={<BeginJourneyPage />} />
              <Route path="/my-consultation" element={<MyConsultationPage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/spiritual-services-agreement" element={<SpiritualServicesAgreementPage />} />
              <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            </Routes>
          </Layout>
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
